import { render } from "./menu-item.vue?vue&type=template&id=550b80c6&scoped=true&ts=true"
import script from "./menu-item.vue?vue&type=script&lang=ts"
export * from "./menu-item.vue?vue&type=script&lang=ts"

import "./menu-item.vue?vue&type=style&index=0&id=550b80c6&lang=scss&scoped=true"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550b80c6"]])

export default __exports__